import styled from 'styled-components';
import { SESSION_TYPES } from '@components/session-timeline/utils/constants';
import { TimelineEventProps } from './types';

export const Wrapper = styled.div``;

type MainProps = Partial<TimelineEventProps>;

export const Main = styled.div<MainProps>`
  display: flex;
  flex-direction: row;
  padding: 0px 20px 20px 20px;
  .left {
    display: flex;
    width: 160px;
    min-width: 160px;
    align-items: center;
    box-sizing: content-box;
    flex-direction: row;
    padding-right: 20px;
    .label {
      line-height: 45px;
      font-size: ${props => (props.type === SESSION_TYPES.NORMAL ? '16px' : '20px')};
      font-weight: ${props => (props.type === SESSION_TYPES.NORMAL ? 300 : 600)};
    }
  }
  .right {
    position: relative;
    flex-grow: 1;
  }
  &.session-overview {
    padding: 0 20px;
    margin-top: 27px;
    flex-direction: column;
    .left {
      width: 200px;
      flex-direction: row;
    }
    .right {
      padding-right: 20px;
    }
  }
`;

export const StyledStateIcon = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 3px;
  background-color: ${props => props.color};
`;

export const ChartLoadingWrapper = styled.div`
  position: relative;
  height: 60px;
`;
